import { Box, Button, Grid } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from "react-router-dom";
import OverRideExplorer from "../../components/organisms/overRideExplorer/OverRideExplorer";

const OverRideList = () => {

    const navigate = useNavigate();

    const addOverRide = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = "/AddOverRide";
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }
    }

    return (
        <>
            <Box sx={{ paddingBottom: "10px" }}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                    <Grid item xs={8}>
                        <h1 style={{ textAlign: "left" }}>Overrides</h1>
                    </Grid>
                    <Grid item xs={4} style={{ textAlign: "right" }}>
                        <Button id="70050857-3e95-468e-8fe3-84c5545b4bb0" color="primary" variant="contained" onClick={addOverRide} endIcon={<AddIcon />}>
                            Add Overrides
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <OverRideExplorer />
        </>
    )
}

export default OverRideList;